import {types} from '@/constants/notification-constants';

export const getNotificationsTypesOptions = () => {
    let array = [];
    Object.keys(types).forEach((key) => {
        array.push({
            value: key,
            text: types[key]
        });
    });
    return array;
};